import { compromissoCompraVendaResolver } from "./compromissoCompraVendaResolver";
import { contratoLocacaoImovelResolver } from "./contratoLocacaoImovelResolver";
import { autorizacaoLocacaoImovelResolver } from "./autorizacaoLocacaoImovelResolver";
import { propostaCompraImovelResolver } from "./propostaCompraImovelResolver";
import { contratoParceriaVendasResolver } from "./contratoParceriaVendasResolver";
import { reciboSimplesResolver } from "./reciboSimplesResolver";
import { autorizacaoGlebaLoteamentoResolver } from "./autorizacaoGlebaLoteamentoResolver";
import { autorizacaoVendaImovelResolver } from "./autorizacaoVendaImovelResolver";

export const resolverRegistry = {
  "compromisso-compra-venda": compromissoCompraVendaResolver,
  "contrato-locacao-imovel": contratoLocacaoImovelResolver,
  "autorizacao-locacao-imovel": autorizacaoLocacaoImovelResolver,
  "proposta-compra-imovel": propostaCompraImovelResolver,
  "contrato-parceria-vendas": contratoParceriaVendasResolver,
  "recibo-simples": reciboSimplesResolver,
  "autorizacao-gleba-loteamento": autorizacaoGlebaLoteamentoResolver,
  "autorizacao-venda-imovel": autorizacaoVendaImovelResolver,
};